import { Injectable } from '@angular/core';

import { DietitianStateProvider } from '../../../../data/dietitian/domain/dietitian_state_provider';
import { PredefinedTask } from '../../../../data/todo/domain/predefined-task';
import { Task } from '../../../../data/todo/domain/task';
import { ToDo } from '../../../../data/todo/domain/todo';
import { ToDoCommands } from '../../../../data/todo/domain/todo_commands';

@Injectable()
export class ToDoModalFacade {
  constructor(
    private toDoCommands: ToDoCommands,
    private dietitianStateProvider: DietitianStateProvider,
  ) {
    // nada
  }

  get dietitianState$() {
    return this.dietitianStateProvider.state$;
  }

  async findAllPredefinedTasks(): Promise<PredefinedTask[]> {
    return this.toDoCommands.findAllPredefinedTasks();
  }

  async findAllTasks(dietitianId: string): Promise<Task[]> {
    return this.toDoCommands.findAllTasks(dietitianId);
  }

  async saveToDo(toDo: ToDo): Promise<ToDo> {
    return this.toDoCommands.saveToDo(toDo);
  }
}
